import Image1 from "../assets/images/other-tool-resource/income-measurement-guidance-tool.png";
import Image2 from "../assets/images/other-tool-resource/cocoa-income-inventory.png";
import Image3 from "../assets/images/other-tool-resource/procurement-library.png";
import Image4 from "../assets/images/other-tool-resource/reporting-standards.png";
import Image5 from "../assets/images/other-tool-resource/procurement-practices-paper-by-DISCO.jpg";
import Image6 from "../assets/images/other-tool-resource/aligned-Inclusive-living-income-narrative-and-indicators.jpg";
import Image7 from "../assets/images/other-tool-resource/inclusive-business-analytics.jpg";
import IDCImg from "../assets/images/home/income-driver-calculator-img.png";

export const otherToolsAndResourcesContent = [
  {
    key: "IMG",
    tag: "Tool",
    image: Image1,
    title: "Income Measurement Guidance Tool",
    description:
      "The tool helps companies streamline their approach to measure actual household income, across multiple commodities and regions, while considering their resource availability and source of data (primary and secondary).",
    order: 1,
    button: {
      href: "https://idh.org/resources/income-measurement-guidance",
      type: "new-window",
      text: "Explore the tool",
    },
  },
  {
    key: "CII",
    tag: "Tool",
    image: Image2,
    title: "Cocoa Income Inventory",
    description:
      "The tool allows you to explore data on cocoa production, income from cocoa, and other key indicators from different origins on an interactive dashboard.",
    order: 2,
    button: {
      href: "/cocoa-income-inventory",
      type: "link",
      text: "Explore the tool",
    },
  },
  {
    key: "PL",
    tag: "Tool",
    image: Image3,
    title: "Procurement Library",
    description:
      "The tool helps businesses identify the best interventions for their goals, access personalized procurement advice, and explore the intervention library.",
    order: 3,
    button: {
      href: "/procurement-library",
      type: "link",
      text: "Explore the tool",
    },
  },
  {
    key: "NDDRS",
    tag: "Paper",
    image: Image4,
    title: "Navigating Due Diligence and Reporting Standards",
    description:
      "This paper by IDH provides guidance on how IDH tools and resources can support Due Diligence and Reporting standards.",
    order: 4,
    button: {
      href: "https://idh.org/resources/living-income-and-living-wage-tools-support-effective-due-diligence",
      type: "new-window",
      text: "Download",
    },
  },
  {
    key: "PPP",
    tag: "Paper",
    image: Image5,
    title: "Procurement Practices Principles",
    description:
      "Introduces the main principles to be adopted by the DISCO partners as part of their living income strategies.",
    order: 5,
    button: {
      href: "https://www.idhsustainabletrade.com/uploaded/2024/04/DISCO-Procurement-Practices-Position-Paper.pdf",
      type: "new-window",
      text: "Download",
    },
  },
  {
    key: "AILINI",
    tag: "Paper",
    image: Image6,
    title: "Aligned Inclusive Living Income Narrative and Indicators",
    description:
      "This publication by LICOP provides guidance on reporting progress towards living income goals in an inclusive manner to foster better sharing and learning.",
    order: 6,
    button: {
      href: "https://www.living-income.com/fileadmin/living_income/The_Concept/Measurement/LICOP_publication_-_Aligned_Inclusive_Living_Income_Narrative_and_Indicators.pdf",
      type: "new-window",
      text: "Download",
    },
  },
  {
    key: "IDH-IBA",
    tag: "Tool",
    image: Image7,
    title: "IDH Inclusive Business Analysis",
    description:
      "Provides insights into the workings and economics of smallholder-inclusive business models, exploring various scenarios and delivering actionable recommendations to enhance efficiency, effectiveness, and sustainability.",
    order: 7,
    button: {
      href: "https://www.idhsustainabletrade.com/business-analytics/",
      type: "new-window",
      text: "Explore the tool",
    },
  },
  {
    key: "IDC",
    tag: "Tool",
    image: IDCImg,
    title: "Income Driver Calculator",
    description:
      "An online tool that supports companies to assess the size of the living income gap. in their supply chain and take data driven decisions on the most effective strategies with the use aggregate data.",
    order: 8,
    button: {
      href: "/income-driver-calculator",
      type: "link",
      text: "Explore the tool",
    },
  },
];
